<template>
  <div>
    <div v-if="data.speakers.length > 0" class="mb-2">
      <div class="regular-18 mb-2">Speakers :</div>
      <speaker :speakers="data.speakers" />
    </div>
    <div v-if="data.lecturers.length > 0" class="mb-2">
      <div class="regular-18 mb-2">Lecturers :</div>
      <speaker :speakers="data.lecturers" />
    </div>
    <div v-if="data.teaching_assistants.length > 0" class="mb-2">
      <div class="regular-18 mb-2">Teaching Assistants :</div>
      <speaker :speakers="data.teaching_assistants" />
    </div>
  </div>
</template>

<script>
import Speaker from '@/components/CommonPages/Speaker.vue'

export default ({
  name: 'TeachingAssistantsAndSpeakersTabSection',
  components: { Speaker },
  props: ['data']
})
</script>
